import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALGROUPLABORATORY_LOAD,
    ACTION_TRIALGROUPLABORATORY_LOAD_BY_TRIALGROUPID,
    ACTION_TRIALGROUPLABORATORY_LOAD_BY_TRIALID,
    ACTION_TRIALGROUPLABORATORY_LOAD_BY_ID,
    ACTION_TRIALGROUPLABORATORY_LOAD_BY_LABORATORY_ID,

    ACTION_TRIALGROUPLABORATORY_SAVE,

    ACTION_TRIALGROUPLABORATORY_CREATE,

    ACTION_TRIALGROUPLABORATORY_DELETE,

    ACTION_TRIALGROUPLABORATORY_VALIDATE,

    ITrialGroupLaboratoriesLoadAction,
    ITrialGroupLaboratoryLoadByIdAction,
    ITrialGroupLaboratoriesLoadByTrialGroupIdAction,
    ITrialGroupLaboratoriesLoadByTrialIdAction,
    ITrialGroupLaboratoryLoadByLaboratoryIdAction,
    ITrialGroupLaboratoryLoadFailureAction,
    ITrialGroupLaboratoryLoadSuccessAction,

    ITrialGroupLaboratorySaveAction,
    ITrialGroupLaboratorySaveSuccessAction,
    ITrialGroupLaboratorySaveFailureAction,

    ITrialGroupLaboratoryCreateAction,
    ITrialGroupLaboratoryCreateSuccessAction,
    ITrialGroupLaboratoryCreateFailureAction,

    ITrialGroupLaboratoryDeleteAction,
    ITrialGroupLaboratoryDeleteSuccessAction,
    ITrialGroupLaboratoryDeleteFailureAction,

    ITrialGroupLaboratoryValidateAction,
    ITrialGroupLaboratoryValidateSuccessAction,
    ITrialGroupLaboratoryValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    DeleteSuccess,
    DeleteFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialGroupLaboratory";
import { trialGroupLaboratoryApi } from "../services/trialGroupLaboratory";

export const
    getTrialGroupLaboratoriesEpic = (action$): Observable<ITrialGroupLaboratoryLoadSuccessAction | ITrialGroupLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORY_LOAD)
            .mergeMap((_action: ITrialGroupLaboratoriesLoadAction) => {
                return trialGroupLaboratoryApi
                    .getTrialGroupLaboratories()
                    .map(response =>
                        LoadSuccess(response.trialGroupLaboratories, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupLaboratoriesByTrialGroupIdEpic = (action$): Observable<ITrialGroupLaboratoryLoadSuccessAction | ITrialGroupLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORY_LOAD_BY_TRIALGROUPID)
            .mergeMap((action: ITrialGroupLaboratoriesLoadByTrialGroupIdAction) => {
                return trialGroupLaboratoryApi
                    .getTrialGroupLaboratoriesByTrialGroupId(action.trialGroupId)
                    .map(response =>
                        LoadSuccess(response.trialGroupLaboratories, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupLaboratoriesByTrialIdEpic = (action$): Observable<ITrialGroupLaboratoryLoadSuccessAction | ITrialGroupLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORY_LOAD_BY_TRIALID)
            .mergeMap((action: ITrialGroupLaboratoriesLoadByTrialIdAction) => {
                return trialGroupLaboratoryApi
                    .getTrialGroupLaboratoriesByTrialId(action.trialId)
                    .map(response =>
                        LoadSuccess(response.trialGroupLaboratories, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupLaboratoryByIdEpic = (action$): Observable<ITrialGroupLaboratoryLoadSuccessAction | ITrialGroupLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORY_LOAD_BY_ID)
            .mergeMap((action: ITrialGroupLaboratoryLoadByIdAction) => {
                return trialGroupLaboratoryApi
                    .getTrialGroupLaboratoryById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialGroupLaboratory, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupLaboratoryByLaboratoryIdEpic = (action$): Observable<ITrialGroupLaboratoryLoadSuccessAction | ITrialGroupLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORY_LOAD_BY_LABORATORY_ID)
            .mergeMap((action: ITrialGroupLaboratoryLoadByLaboratoryIdAction) => {
                return trialGroupLaboratoryApi
                    .getTrialGroupLaboratoryByLaboratoryId(action.laboratoryId)
                    .map(response =>
                        LoadSuccess(response.trialGroupLaboratory, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialGroupLaboratoryEpic = (action$): Observable<ITrialGroupLaboratorySaveSuccessAction | ITrialGroupLaboratorySaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORY_SAVE)
            .mergeMap((action: ITrialGroupLaboratorySaveAction) => {
                return trialGroupLaboratoryApi
                    .setTrialGroupLaboratory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialGroupLaboratory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialGroupLaboratoryEpic = (action$): Observable<ITrialGroupLaboratoryCreateSuccessAction | ITrialGroupLaboratoryCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORY_CREATE)
            .mergeMap((action: ITrialGroupLaboratoryCreateAction) => {
                return trialGroupLaboratoryApi
                    .createTrialGroupLaboratory(action.laboratoryId, action.trialGroupId)
                    .map(response =>
                        CreateSuccess(response.trialGroupLaboratory, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    deleteTrialGroupLaboratoryEpic = (action$): Observable<ITrialGroupLaboratoryDeleteSuccessAction | ITrialGroupLaboratoryDeleteFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORY_DELETE)
            .mergeMap((action: ITrialGroupLaboratoryDeleteAction) => {
                return trialGroupLaboratoryApi
                    .deleteTrialGroupLaboratory(action.id)
                    .map(_response =>
                        DeleteSuccess()
                    )
                    .catch(error =>
                        Observable.of(DeleteFailure(error.responseStatus))
                    )
            });
    },
    validateTrialGroupLaboratoryEpic = (action$): Observable<ITrialGroupLaboratoryValidateSuccessAction | ITrialGroupLaboratoryValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPLABORATORY_VALIDATE)
            .mergeMap((action: ITrialGroupLaboratoryValidateAction) => {
                return trialGroupLaboratoryApi
                    .validateTrialGroupLaboratory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialGroupLaboratory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }